import _defineProperty from "/home/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createOutlineStyles } from './focus';
var mediumButtonSize = {
  borderRadius: 8,
  fontSize: 18,
  lineHeight: 24
};
var largeButtonSize = {
  borderRadius: 8,
  fontSize: 18,
  lineHeight: 24
};
var mediumButtonSpacing = {
  paddingTop: 8,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12
};
var largeButtonSpacing = {
  paddingTop: 11,
  paddingRight: 16,
  paddingBottom: 11,
  paddingLeft: 16
};
var sizes = {
  small: mediumButtonSize,
  medium: mediumButtonSize,
  large: largeButtonSize,
  dsSm: mediumButtonSize,
  dsMd: mediumButtonSize,
  dsLg: largeButtonSize
};
var spacing = {
  small: mediumButtonSpacing,
  medium: mediumButtonSpacing,
  large: largeButtonSpacing,
  dsSm: mediumButtonSpacing,
  dsMd: mediumButtonSpacing,
  dsLg: largeButtonSpacing
};

var createButtonStyle = function createButtonStyle(variant) {
  var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread({
    background: "var(--wcds-colors-background-btn-".concat(variant, "-idle)"),
    border: "1px solid var(--wcds-colors-border-btn-".concat(variant, "-idle)"),
    color: "var(--wcds-colors-text-btn-".concat(variant, "-idle)"),
    ':hover': {
      background: "var(--wcds-colors-background-btn-".concat(variant, "-hover)"),
      borderColor: "var(--wcds-colors-border-btn-".concat(variant, "-hover)"),
      color: "var(--wcds-colors-text-btn-".concat(variant, "-hover)")
    },
    ':active, &[aria-expanded="true"]': {
      background: "var(--wcds-colors-background-btn-".concat(variant, "-down)"),
      borderColor: "var(--wcds-colors-border-btn-".concat(variant, "-down)"),
      color: "var(--wcds-colors-text-btn-".concat(variant, "-down)")
    },
    ':focus-visible': createOutlineStyles({
      styles: {
        background: "var(--wcds-colors-background-btn-".concat(variant, "-focus)"),
        borderColor: "var(--wcds-colors-border-btn-".concat(variant, "-focus)"),
        color: "var(--wcds-colors-text-btn-".concat(variant, "-focus)")
      }
    })
  }, styles);
};

var primaryButtonStyles = createButtonStyle('primary');
var secondaryButtonStyles = createButtonStyle('secondary');
var buttons = {
  sizes: sizes,
  spacing: spacing,
  variants: {
    primary: primaryButtonStyles,
    secondary: secondaryButtonStyles,
    dropdown: createButtonStyle('dropdown', {
      '&& > span': {
        display: 'block',
        paddingRight: 48,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    }),

    /**
     * @deprecated - use `primary` instead
     */
    dsPrimary: primaryButtonStyles,

    /**
     * @deprecated - use `secondary` instead
     */
    dark: secondaryButtonStyles,

    /**
     * @deprecated - use `secondary` instead
     */
    dsTransparent: secondaryButtonStyles,

    /**
     * @deprecated - use `secondary` instead
     */
    secondaryBlue: secondaryButtonStyles,

    /**
     * @deprecated - use `secondary` instead
     */
    transparent: secondaryButtonStyles,

    /**
     * @deprecated - use `secondary` instead
     */
    transparentWhite: secondaryButtonStyles,

    /**
     * @deprecated - use `secondary` instead
     */
    white: secondaryButtonStyles
  },

  /**
   * @deprecated
   */
  withArrowSpacing: spacing
};
export default buttons;